import { useState } from 'react';
import PropTypes from 'prop-types';
import Button from 'components/UI/Button';
import useLiterals from 'utils/hooks/useLiterals';
import Modal from 'components/Modal';
import { OTP_LENGTH } from 'constants/global';
import Translate from 'components/Translate';
import InputOtp from 'components/UI/InputOtp';

const OtpModal = ({
  show,
  title = '',
  description = '',
  otpType,
  isLoading = false,
  onSubmit,
  onClose,
}) => {
  const literals = useLiterals('auth');
  const [otp, setOtp] = useState('');

  if (!show) return null;

  return (
    <Modal position='end' onClose={onClose} animation='slide-up-enter'>
      <h1 className='text-primary mb-6'>{title || literals.otpModal.title}</h1>
      <Translate
        component='h3'
        className='font-normal mb-6'
        literal={description || literals.otpModal.info}
        vars={{ type: literals[otpType], length: OTP_LENGTH }}
      />
      <InputOtp onChange={setOtp} />
      <Button
        className='mt-12'
        loading={isLoading}
        text={literals.common.continue}
        onClick={() => onSubmit(otp)}
        disabled={!otp || otp.length < OTP_LENGTH}
      />
      <div className='mt-6 mb-12 text-right underline cursor-pointer'>
        {literals.otpModal.codeNotReceived}
      </div>
    </Modal>
  );
};

OtpModal.propTypes = {
  show: PropTypes.bool.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  otpType: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default OtpModal;
